import type { MapInteractionEventData } from '../trackMapInteraction';
import { trackMapInteraction } from '../trackMapInteraction';

export const trackZoomLevelChangeOnce = (
  googleApi: typeof google,
  map: google.maps.Map,
  changeZoomLevel: MapInteractionEventData,
): void => {
  googleApi.maps.event.addListenerOnce(map, 'zoom_changed', () => {
    trackMapInteraction(changeZoomLevel);
  });
};
